<div class="field" #fieldName>
    <span class="field-title">Número de facturación<span class="asterisk">*</span></span>

    <div>
        <text-input [initialPlaceHolder]="'Ingresar un número de facturación'" 
        [value]="elementSelected" (valueOut)="setElement($event)"></text-input>
    </div>
</div>